// Reflection headline — `Lesson N · {verb}` set in serif at text-display.
// The trailing period IS the discipline (§12.2 / §12.3 anti-celebration ban) —
// no exclamation, no medal. Lesson-number tabular cartouche so the eye
// doesn't re-measure between Lesson 02 and Lesson 56.
//
// The verb is the load-bearing register difference between paths (Learn /
// Review / Quiz / Challenge complete · Challenge paused). No chromatic
// differentiation, no badge — the verb alone carries it.
export function ReflectionHeadline({
    lessonNumber,
    verb,
}: {
    lessonNumber: number
    verb: string
}) {
    const padded = String(lessonNumber).padStart(2, '0')
    return (
        <h1 className="mt-6 font-serif text-3xl leading-[1.15] tracking-tight text-ink md:mt-8 md:text-4xl">
            <span className="tabular-nums">Lesson {padded}</span>
            <span className="mx-2 font-light text-muted-fg" aria-hidden>
                ·
            </span>
            <span>{verb}</span>
        </h1>
    )
}
